(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newDocument', {
            bindings: {
                gfilestep: '<',
                gfile: '<',
                updatetree: '=',
                newdocumentform: '=',
                editdocumentform: '=',
                document: '='
            },
            templateUrl: 'app/entities/document/new-document-component.html',
            controller: ['$scope', 'Upload', 'Document',  'toastr',
                function ($scope, Upload, Document,  toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.uploadfile = uploadfile;
                    $ctrl.close = close;

                    $ctrl.document = {};

                    $scope.$watch('$ctrl.newdocumentform', function() {
                        if ($ctrl.newdocumentform === true) {
                            $ctrl.document = {};
                        }
                    });

                    function initialization() {

                    }

                    function save() {
                        $ctrl.isSaving = true;
                        $ctrl.document.signed = false;
                        var gFileStep = {"id": $ctrl.gfilestep.id};
                        var document = Object.assign({}, $ctrl.document);
                        document.gFileStep = gFileStep;
                        Document.save(document, onSaveSuccess, onSaveError);
                    }

                    function uploadfile(file, errFiles) {
                      if (file) {
                        $ctrl.file = file;
                        $ctrl.document.filename = file.name;
                      }
                    }

                    function upload() {
                      Upload.upload({
                                url: "api/g-files/upload",
                                data: {
                                    file: $ctrl.file,
                                    name: $ctrl.file.name,
                                    previousFile: "",
                                    gFileID: $ctrl.gfile.id,
                                    documentID: $ctrl.document.id
                                },
                                method: 'POST'
                            }).then(
                                function() {
                                    $ctrl.isSaving = false;
                                    toastr.success('Documento subido con éxito');
                                    Document.get({id: $ctrl.document.id}, onUploadSuccess, onUploadError);
                                },
                                function(response) {
                                    $ctrl.isSaving = false;
                                    toastr.error('Error al subir el documento');
                                    Document.get({id: $ctrl.document.id}, onUploadSuccess, onUploadError);
                                },
                                function() {});
                    }

                    function onSaveSuccess(result) {
//                        toastr.success('Documento creado con éxito');
                        $ctrl.updatetree = true;
                        $ctrl.newdocumentform = false;
                        $ctrl.editdocumentform = false;
                        $ctrl.isSaving = false;
                        $ctrl.document = result;

                        upload();
                    }

                    function onSaveError() {
                        toastr.error('Error al crear el documento');
                        $ctrl.isSaving = false;
                    }

                    function onUploadSuccess(result) {
/*                        $scope.$emit('expedientesUriarteApp:gFileStepUpdate', result); */
                    }

                    function onUploadError() {
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.newdocumentform = false;
                    }

                }
            ]
        });
})();
